// Hardcoded issues
export const HARDCODED_ISSUES = [
  {
    id: 'health',
    name: 'Health',
    description: 'General health concerns and healthcare access issues affecting individuals and communities.',
    category: 'Social',
    searchTerms: ['health', 'healthcare', 'wellness', 'medical', 'hospital', 'doctor', 'medicine']
  },
  {
    id: 'water_scarcity',
    name: 'Water Scarcity',
    description: 'Limited access to clean and safe drinking water, affecting billions worldwide.',
    category: 'Environment',
    searchTerms: ['water', 'drought', 'hydration', 'thirst', 'sanitation', 'clean water', 'drinking water']
  },
  {
    id: 'poverty',
    name: 'Poverty',
    description: 'Extreme lack of resources and economic opportunities resulting in inability to meet basic needs.',
    category: 'Social',
    searchTerms: ['poverty', 'poor', 'financial hardship', 'economic deprivation', 'low income']
  },
  {
    id: 'food-insecurity',
    name: 'Food Insecurity',
    description: 'Limited or uncertain access to nutritious, safe, and adequate food for healthy living.',
    category: 'Social',
    searchTerms: ['hunger', 'starvation', 'food access', 'nutrition', 'meal', 'food shortage']
  },
  {
    id: 'obesity',
    name: 'Obesity',
    description: 'Excessive body fat accumulation presenting health risks and associated with numerous chronic diseases.',
    category: 'Health',
    searchTerms: ['overweight', 'weight issues', 'diet', 'unhealthy eating', 'nutrition', 'fat']
  },
  {
    id: 'disease',
    name: 'Disease',
    description: 'Spread and impact of infectious and chronic diseases affecting quality of life and mortality.',
    category: 'Health',
    searchTerms: ['illness', 'infection', 'pandemic', 'epidemic', 'virus', 'bacteria', 'sickness']
  },
  {
    id: 'food-waste',
    name: 'Food Waste',
    description: 'Discarding of edible food in homes, businesses, and supply chains contributing to resource waste.',
    category: 'Environment',
    searchTerms: ['waste', 'disposal', 'leftovers', 'expired food', 'composting', 'surplus food']
  },
  {
    id: 'homelessness',
    name: 'Homelessness',
    description: 'Individuals and families without stable, safe, and adequate housing or permanent residence.',
    category: 'Social',
    searchTerms: ['homeless', 'housing crisis', 'shelter', 'street living', 'unhoused', 'houseless']
  },
  {
    id: 'education',
    name: 'Education',
    description: 'Access to quality learning opportunities and barriers to educational achievement.',
    category: 'Social',
    searchTerms: ['school', 'learning', 'teaching', 'academic', 'literacy', 'education access', 'classroom']
  },
  {
    id: 'natural-disasters',
    name: 'Natural Disasters',
    description: 'Catastrophic events causing widespread damage, destruction, and human suffering.',
    category: 'Environment',
    searchTerms: ['disaster', 'earthquake', 'hurricane', 'flood', 'wildfire', 'tornado', 'tsunami']
  },
  {
    id: 'climate-change',
    name: 'Climate Change',
    description: 'Global warming and its impacts including rising sea levels, extreme weather, and ecosystem disruption.',
    category: 'Environment',
    searchTerms: ['global warming', 'carbon emissions', 'greenhouse gases', 'rising temperatures', 'melting ice']
  },
  {
    id: 'racism',
    name: 'Racism',
    description: 'Discrimination, prejudice, and antagonism directed at individuals based on race or ethnicity.',
    category: 'Social',
    searchTerms: ['discrimination', 'prejudice', 'racial bias', 'ethnicity', 'xenophobia', 'racial inequality']
  },
  {
    id: 'crime',
    name: 'Crime',
    description: 'Illegal activities ranging from petty offenses to organized and violent criminal behavior.',
    category: 'Social',
    searchTerms: ['illegal', 'criminal', 'law breaking', 'theft', 'offense', 'felony', 'misdemeanor']
  },
  {
    id: 'violence',
    name: 'Violence',
    description: 'Physical force intended to hurt, damage, or kill someone or something in various contexts.',
    category: 'Social',
    searchTerms: ['assault', 'abuse', 'fighting', 'harm', 'aggression', 'conflict', 'force']
  },
  {
    id: 'substance-abuse',
    name: 'Substance Abuse',
    description: 'Harmful or hazardous use of psychoactive substances including alcohol and illicit drugs.',
    category: 'Health',
    searchTerms: ['addiction', 'alcoholism', 'drug use', 'dependency', 'overdose', 'substance use disorder']
  },
  {
    id: 'refugee',
    name: 'Refugee',
    description: 'People forced to flee their countries due to persecution, war, or violence seeking safety elsewhere.',
    category: 'Social',
    searchTerms: ['asylum seeker', 'displaced person', 'migration', 'humanitarian crisis', 'exile']
  },
  {
    id: 'corruption',
    name: 'Corruption',
    description: 'Dishonest or fraudulent conduct by those in power, typically involving bribery or fraud.',
    category: 'Social',
    searchTerms: ['bribery', 'fraud', 'scandal', 'embezzlement', 'misconduct', 'nepotism', 'graft']
  },
  {
    id: 'pollution',
    name: 'Pollution',
    description: 'Introduction of harmful substances into the environment causing adverse changes.',
    category: 'Environment',
    searchTerms: ['contamination', 'waste', 'toxic', 'smog', 'oil spill', 'plastic', 'litter']
  },
  {
    id: 'disability',
    name: 'Disability',
    description: 'Physical or mental conditions that limit a person\'s movements, senses, or activities.',
    category: 'Social',
    searchTerms: ['handicap', 'impairment', 'special needs', 'accessibility', 'inclusive design', 'accommodation']
  },
  {
    id: 'child-labor',
    name: 'Child Labor',
    description: 'Work that deprives children of their childhood, potential, dignity, and is harmful to physical and mental development.',
    category: 'Social',
    searchTerms: ['exploitation', 'underage work', 'child abuse', 'sweatshop', 'forced labor', 'youth workers']
  },
  {
    id: 'human-trafficking',
    name: 'Human Trafficking',
    description: 'Trade of humans for the purpose of forced labor, sexual slavery, or commercial sexual exploitation.',
    category: 'Social',
    searchTerms: ['modern slavery', 'exploitation', 'forced labor', 'sex trafficking', 'abduction', 'smuggling']
  }
];
